import { createAPI } from "./api/api";

const api = createAPI();

export const updateProfileDataRequest = async (payload) => {
  await api.post(`/me/update_profile`, payload).catch((error) => console.log('Change flags error', error));
}
